import React from 'react';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { Platform, StyleProp, View, ViewStyle } from 'react-native';

interface Props {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}

/**
 * Wraps action sheet content in a KeyboardAwareScrollView on Android.
 * On iOS, react-native-modal's avoidKeyboard already handles this via
 * KeyboardAvoidingView with behavior="padding". On Android, that behavior
 * is set to undefined (a no-op), so we need KeyboardAwareScrollView.
 */
export const ActionSheetKeyboardAwareView: React.FC<Props> = ({
  children,
  style,
}) => {
  if (Platform.OS === 'android') {
    return (
      <KeyboardAwareScrollView
        alwaysBounceVertical={false}
        bottomOffset={24}
        contentContainerStyle={style}
      >
        {children}
      </KeyboardAwareScrollView>
    );
  }

  return <View style={style}>{children}</View>;
};
